// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionCard-cls1_m5g","cls2":"SuggestionCard-cls2_EEQ SuggestionCard-cls1_m5g","small":"SuggestionCard-small_c1w"};